import { render } from "./MIndexCenter.vue?vue&type=template&id=2eb8fc0c&scoped=true"
import script from "./MIndexCenter.vue?vue&type=script&lang=js"
export * from "./MIndexCenter.vue?vue&type=script&lang=js"

import "./MIndexCenter.vue?vue&type=style&index=0&id=2eb8fc0c&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb8fc0c"]])

export default __exports__